import { Component } from '@angular/core';

@Component({
  selector: 'ebw-monorepo-nio-empty-page',
  templateUrl: './nio-empty-page.component.html'
})
export class NioEmptyPageComponent {}
